// Unit tokens that must keep their lowercase spelling inside uppercased labels.
export const UNIT_SPLIT_RE = /(?<!\p{L})(kWh|kg|hrs?|wk|weeks?|yrs?)(?!\p{L})/u;

export function upperKeepUnits(str) {
  return String(str ?? "")
    .split(UNIT_SPLIT_RE)
    .map((part, i) => (i % 2 ? part : part.toUpperCase()))
    .join("");
}
